import type { CSSProperties, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface MarqueeProps {
    children: ReactNode
    /** Seconds for one full loop. Higher is slower. */
    duration?: number
    direction?: 'left' | 'right'
    className?: string
    trackClassName?: string
    pauseOnHover?: boolean
}

/**
 * Seamless CSS marquee. The children are rendered twice and the track slides
 * exactly -50%, so the loop has no visible seam and needs no JS tick.
 */
export const Marquee = ({
    children,
    duration = 40,
    direction = 'left',
    className,
    trackClassName,
    pauseOnHover = true
}: MarqueeProps): ReactNode => {
    return (
        <div
            className={cn(
                'relative w-full overflow-hidden',
                pauseOnHover && 'marquee-host',
                className
            )}
        >
            <div
                className={cn('marquee-track', trackClassName)}
                data-direction={direction}
                style={{ '--marquee-duration': `${duration}s` } as CSSProperties}
            >
                <div className='flex shrink-0 items-center' aria-hidden='false'>
                    {children}
                </div>

                <div className='flex shrink-0 items-center' aria-hidden='true'>
                    {children}
                </div>
            </div>
        </div>
    )
}
